import api, { ValidateAxiosError } from '@/modules/api.service';
import { Dashboard, DashBoardMovimentosDto, DashboardResumoDia } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';

export async function GetDashboardDia(dia: Date) {
  return api
    .get<DashboardResumoDia>(Endpoints.DASHBOARD + '/' + dia)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<DashboardResumoDia>(
        error,
        'Falha ao buscar dashboard.',
      );
    });
}

export async function GetDashboardDefensores(
  dia: Date,
  naovazio: boolean | string,
) {
  return api
    .get<Dashboard[]>(Endpoints.DASHBOARD, {
      params: { dia: dia, naovazio: naovazio },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<Dashboard[]>(
        error,
        'Falha ao buscar dashboard.',
      );
    });
}

export async function GetDashboardMovimentos(
  referenciaI: string,
  referenciaF: string,
  defensoriaId: number,
  nucleoId: number,
  defensorId: number,
) {
  const requisicao =
    Endpoints.DASHBOARD +
    '/movimentacoes' +
    '/' +
    referenciaI +
    '?referenciaf=' +
    referenciaF +
    '&defensoriaId=' +
    defensoriaId +
    '&nucleoId=' +
    nucleoId +
    '&defensorId=' +
    defensorId;

  return api
    .get<DashBoardMovimentosDto[]>(requisicao)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<DashBoardMovimentosDto[]>(
        error,
        'Falha ao buscar dashboard.',
      );
    });
}